import qs from 'qs'
import axios from '../../index'

/**
 * @description 限时秒杀
 * http://192.168.2.177:3000/project/21/interface/api/1298
 * @author txw
 * @date 2019-08-19
 * @export
 */
export function getSeckillList (params) {
  return axios.post('/product/load-seckill-goods', qs.stringify(params))
}
